import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { NavItem } from '@shared/models/menu.inteface';
import { Router } from '@angular/router';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { MenuActiveService } from '../menu-active.service';

@Component({
  selector: 'app-menu-list-item',
  templateUrl: './menu-list-item.component.html',
  styleUrls: ['./menu-list-item.component.scss'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ]),
  ],
})
export class MenuListItemComponent implements OnInit {
  expanded: boolean = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem;
  @Input() depth: number;

  constructor(public router: Router, private menuActiveSvc: MenuActiveService) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    if (this.hasActiveDescendant(this.item)) {
      this.expanded = true;
      this.ariaExpanded = this.expanded;
    }
  }

  onItemSelected(item: NavItem) {
    if (!item.Nodes || !item.Nodes.length) {
      if (item.Uri != undefined) {
        this.router.navigate([item.Uri]);
      } else {
        this.router.navigate(["home"]);
      }
    } else {
      this.expanded = !this.expanded;
      this.ariaExpanded = this.expanded;
    }
  }

  isRouteActive(uri: string): boolean {
    const currentUrl = this.router.url.split('?')[0].split('#')[0].replace(/^\//, '');

    // Coincidencia exacta con el URI del ítem
    if (currentUrl === uri) return true;

    // La ruta actual cuelga de este URI, pero solo cuenta si ningún otro
    // ítem del menú (p. ej. un hermano como "invoice/payments-list") es
    // una coincidencia más específica para la misma ruta.
    if (!currentUrl.startsWith(`${uri}/`)) return false;

    return this.menuActiveSvc.isLongestMatch(uri, currentUrl);
  }
  // Usado para el resaltado visual (clase 'active') de la propia fila del
  // ítem. Los ítems padre (con Nodes) nunca se resaltan a sí mismos -aunque
  // tengan su propio Uri, incluso si duplica el de un hijo, p. ej.
  // "Cotizaciones" y su hijo "Cotizaciones" comparten Uri "sale-orders"-,
  // para que padre e hijo no aparezcan ambos resaltados para la misma
  // pantalla. Solo se auto-expanden vía hasActiveDescendant.
  isItemActive(item: NavItem): boolean {
    if (item.Nodes?.length) return false;
    if (!item.Uri) return false;

    return this.isRouteActive(item.Uri);
  }

  // Usado solo para decidir si un padre debe auto-expandirse al cargar,
  // porque la ruta activa está en algún descendiente.
  hasActiveDescendant(item: NavItem): boolean {
    if (this.isItemActive(item)) return true;

    return !!item.Nodes?.some(child => this.hasActiveDescendant(child));
  }
}
